import { useNavigate } from "react-router-dom";
import { SaveIcon } from "../../../../assets/icons";
import { FallbackImage } from "../../../../assets/img";
import Modal from "../../../../components/ui/Modal/Modal";
import { Pagination } from "../../../../components/ui/Table/Pagination/Pagination";

export default function TempTableCheckInventory() {
  const table = {
    row: [
      {
        no: "6",
        sort: "스마트팩토리 연동",
        status: "연동",
        qrNo: "0108800752001671122060817270607",
        lotNo: "LOTATEST123450",
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qntWarehouse: 100,
        updatedAt: "2022-01-02",
      },
      {
        no: "6",
        sort: "스마트팩토리 연동",
        status: "연동",
        qrNo: "0108800752001671122060817270607",
        lotNo: "LOTATEST123450",
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qntWarehouse: 100,
        updatedAt: "2022-01-02",
      },
      {
        no: "6",
        sort: "스마트팩토리 연동",
        status: "연동",
        qrNo: "0108800752001671122060817270607",
        lotNo: "LOTATEST123450",
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qntWarehouse: 100,
        updatedAt: "2022-01-02",
      },
    ],
    header: [
      {
        id: 1,
        title: "번호",
      },
      {
        id: 2,
        title: "구분",
      },
      {
        id: 3,
        title: (
          <span>
            API
            <br />
            연동여부
          </span>
        ),
      },
      {
        id: 4,
        title: "QR번호",
      },
      {
        id: 5,
        title: "LOT",
      },
      {
        id: 6,
        title: "제조일자",
      },
      {
        id: 7,
        title: "유효일자",
      },

      {
        id: 8,
        title: "입고수량",
      },

      {
        id: 9,
        title: "최종 업데이트일",
      },
    ],
  };
  return (
    <>
      <div className="w-full px-6 block whitespace-nowrap overflow-auto -mt-3">
        <table className="w-full text-center">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd] font-normal"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {table.row.map((row, idx) => (
              <>
                <tr key={idx}>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.no}
                  </td>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.sort}
                  </td>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.status}
                  </td>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.qrNo}
                  </td>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.lotNo}
                  </td>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.manufacDate}
                  </td>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.expireDate}
                  </td>

                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.qntWarehouse}
                  </td>
                  <td className="p-3 border border-[#dddddd]" key={idx}>
                    {row?.updatedAt}
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      {/* <div className="mt-8 flex justify-center overflow-auto w-full">
        <Pagination
          total={1}
          page={0}
          isDisabledPrevPage={false}
          isDisabledNextPage={false}
          onPrevClick={() => {}}
          onNextClick={() => {}}
          onChange={() => {}}
        />
        <div className="flex-none">
          <Modal
            hasCancel={false}
            description="다운로드 되었습니다."
            onSubmit={() => {}}
          >
            <button className="p-[10px] border border-[#cccccc] rounded-[4px] text-[#333333]">
              <div className="flex items-center gap-2">
                <SaveIcon />
                엑셀 저장
              </div>
            </button>
          </Modal>
        </div>
      </div> */}
    </>
  );
}
